
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.124 3.708A5.792 5.792 0 0012 2a5.797 5.797 0 00-4.125 1.708c-2.274 2.274-2.274 5.975.007 8.256L12 15.992l4.124-4.035a5.796 5.796 0 001.71-4.125 5.796 5.796 0 00-1.71-4.124zM12 10.325a2.5 2.5 0 110-5 2.5 2.5 0 010 5zm-9.36 6.676l5.292.008L7.306 22H2l.013-1.392L2.639 17zm5.59-2.365l-.09.707-5.21-.009.87-5.002h1.13a7.525 7.525 0 001.787 2.824l1.512 1.48zM22 20.749V22h-5.306l-.624-4.977 5.288.008.642 3.72zm-7.61-3.73l.625 4.98h-6.03l.627-4.987 1.049.001 1.34 1.31 1.335-1.306 1.055.002h-.001zm6.68-1.656l-5.21-.008-.09-.72 1.533-1.5a7.473 7.473 0 001.772-2.803h1.126l.869 5.031z"}})])
          )
        }
      }
    